'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var clsx = require('clsx');
var Box_module = require('./Box.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const Box = _ref => {
  let {
    as: Component = 'div',
    gap,
    px,
    py,
    display,
    className,
    children,
    ...rest
  } = _ref;
  const containerClasses = clsx__default["default"](Box_module["default"].container, gap && Box_module["default"][`gap${gap}`], px && Box_module["default"][`px${px}`], py && Box_module["default"][`py${py}`], Box_module["default"][display ?? 'grid'], className);
  return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
    className: containerClasses
  }, rest), children);
};

exports["default"] = Box;
